"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Explanation_1 = __importDefault(require("../Explanation"));
const writtenNumbers_1 = __importDefault(require("../writtenNumbers"));
const common_1 = require("./common");
function Composantes({ nodeValue, explanation, unit }) {
    return (jsx_runtime_1.jsxs(common_1.Mecanism, Object.assign({ name: "composantes", displayName: false, value: nodeValue, unit: unit }, { children: [jsx_runtime_1.jsxs(common_1.CapitalizeFirstLetter, { children: ["La somme de ", writtenNumbers_1.default[explanation.length], ' ', jsx_runtime_1.jsx(common_1.InlineMecanismName, { name: "composantes" }, void 0), " :"] }, void 0),
            jsx_runtime_1.jsx("ol", { children: explanation.map((c, i) => [
                    jsx_runtime_1.jsxs("li", { children: [jsx_runtime_1.jsx(Explanation_1.default, { node: c }, void 0),
                            jsx_runtime_1.jsx("div", Object.assign({ style: {
                                    textAlign: 'center',
                                    width: '100%',
                                    fontSize: '2.6rem',
                                    margin: '0.4em 0 0.2em',
                                } }, { children: i === explanation.length - 1 ? null : '+' }), void 0)] }, i),
                ]) }, void 0)] }), void 0));
}
exports.default = Composantes;
